import { composeIO } from 'react-compose-io'
import { dadosHistoricoIO } from './DadosHistorico.IO'
import { DadosHistoricoView } from './DadosHistorico.View'

export const DadosHistorico = composeIO(DadosHistoricoView, dadosHistoricoIO)
